import React from 'react'
import {useLoadScript, GoogleMap} from '@react-google-maps/api'
import gql from 'graphql-tag'

import BookingMarker from './BookingMarker'

import './index.css'
// https://developers.google.com/maps/documentation/javascript/style-reference
import mapStyles from './map-styles.json'

class MapComponent extends React.Component {
  state = {
    expandedBooking: false,
  }

  onMapMounted = (map) => {
    if (!map) return

    const bounds = new window.google.maps.LatLngBounds()
    this.props.bookings.edges.forEach(({node: {estate}}) => {
      if (estate.location) bounds.extend(estate.location)
    })
    map.fitBounds(bounds)
  }

  onExpand = (expandedBooking) => this.setState({expandedBooking})
  onClose = () => this.setState({expandedBooking: null})

  render() {
    const {bookings} = this.props
    const {expandedBooking} = this.state

    return (
      <GoogleMap
        id="booking-map"
        onLoad={this.onMapMounted}
        zoom={window.ENV.MAP_DEFAULTS.zoom}
        center={window.ENV.MAP_DEFAULTS.location}
        options={{
          streetViewControl: false,
          rotateControl: false,
          mapTypeControl: false,
          styles: mapStyles,
        }}
      >
        {bookings.edges.map(({node: booking}, index) =>
          <BookingMarker
            key={booking.id}
            booking={booking}
            label={`${index + 1}`}
            expanded={expandedBooking === booking.id}
            onExpand={this.onExpand.bind(this, booking.id)}
            onClose={this.onClose}
          />
        )}
      </GoogleMap>
    )
  }
}

const BookingsMap = ({bookings}) => {
  const {isLoaded, loadError} = useLoadScript({
    googleMapsApiKey: window.ENV.GOOGLE_API_TOKEN,
  })
  if (loadError) {
    return (<div>Problem loading map!</div>)
  }
  if (isLoaded) {
    return (
      <MapComponent bookings={bookings} />
    )
  }

  return null
}

BookingsMap.fragments = {
  bookingsMap: gql`
    fragment BookingsMap on BookingsConnection {
      edges {
        node {
          ...BookingMarker
        }
      }
    }
    ${BookingMarker.fragments.bookingMarker}
  `,
}

export default BookingsMap
